// src/pages/EstoquePage/EstoquePage.jsx
import React from "react";
import UploadNotaXML from "features/estoque/components/UploadNotaXML";
import ListaEstoque from "features/estoque/components/ListaEstoque";
import DashboardEstoque from "features/estoque/components/DashboardEstoque";

const EstoquePage = () => {
  return (
    <div className="flex flex-col gap-6 max-w-7xl mx-auto w-full">
      <div className="text-center mb-2">
        <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-foreground">
          Controle de Estoque
        </h1>
        <p className="text-muted-foreground mt-2">
          Gerencie o estoque do parque importando XMLs de Notas Fiscais Eletrônicas (NFe/NFCe).
        </p>
      </div>

      {/* Grid de Widgets do Estoque */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="col-span-1 lg:col-span-2">
          <DashboardEstoque />
        </div>
        
        <div className="col-span-1 lg:col-span-2">
          <UploadNotaXML />
        </div>
        
        <div className="col-span-1 lg:col-span-2">
          <ListaEstoque />
        </div>
      </div>
    </div>
  );
};
export default EstoquePage;
